export const applyCellStyle = (cell, style) => {
  if (!style) return;
  Object.assign(cell, style);
};

export const mergeCells = (worksheet, row, startCol, endCol) => {
  if (endCol > startCol) {
    worksheet.mergeCells(row, startCol, row, endCol);
  }
};

export const setCellValue = (cell, value, style = null) => {
  cell.value = value;
  if (style) applyCellStyle(cell, style);
};

export const hexColor = (value) => {
  return `FF${value.split('#')[1]}`
}